import Box from 'UIKit/Box/Box'
import Text from 'UIKit/Text/Text'
import { ICommonBonus } from 'config/types/bonus'
import { UserBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { isCashbackBonusType } from 'utils/bonus'
import { useDisplayBonusName } from 'views/BonusCenter/hooks'

import TxIDBonusSection from '../../TxIDBonusSection/TxIDBonusSection'

interface BonusNameSectionDetailsProps {
  bonus: ICommonBonus
}

const BonusNameSectionDetails: React.FC<BonusNameSectionDetailsProps> = ({ bonus }) => {
  const [name] = useDisplayBonusName(bonus.info?.name)
  const { t } = useTranslation()

  const bonusName =
    name ||
    (isCashbackBonusType(bonus)
      ? t('{{bonusCashbackRatePercent}}% Cashback Bonus', {
          bonusCashbackRatePercent: bonus.cashbackRate,
        })
      : '')

  return (
    <Box mb="28px" ml="12px">
      {bonus.info.badge && (
        <Text fontSize="12px" fontWeight="500" color="textSubtle" mb="5px">
          {bonus.info?.badge}
        </Text>
      )}

      <Text fontSize="16px" fontWeight="600">
        {bonusName}
      </Text>

      {bonus instanceof UserBonus && <TxIDBonusSection bonus={bonus} />}
    </Box>
  )
}

export default BonusNameSectionDetails
